import { FormControl } from '@angular/forms';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-upload-content-terms-accept',
    templateUrl: './upload-content-terms-accept.component.html',
    styleUrls: ['./upload-content-terms-accept.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- legacy component, migrate to OnPush when touched
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class UploadContentTermsAcceptComponent {
    @Input() termsAcceptControl!: FormControl<boolean>;
}
